"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetupIntentStatus = void 0;
/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
var SetupIntentStatus;
(function (SetupIntentStatus) {
    SetupIntentStatus["REQUIRES_PAYMENT_METHOD"] = "requires_payment_method";
    SetupIntentStatus["REQUIRES_CONFIRMATION"] = "requires_confirmation";
    SetupIntentStatus["REQUIRES_ACTION"] = "requires_action";
    SetupIntentStatus["PROCESSING"] = "processing";
    SetupIntentStatus["CANCELED"] = "canceled";
    SetupIntentStatus["SUCCEEDED"] = "succeeded";
})(SetupIntentStatus || (exports.SetupIntentStatus = SetupIntentStatus = {}));
